import {observer, StyledProps, React, classNames} from '@api'
import {Fragment, useState} from 'react'
import {Accordion as ExpansionPanel, TextField, Checkbox, FormControlLabel, FormControl, InputLabel, Select, MenuItem, Input, ListItem, ListItemText, ListItemSecondaryAction, FormLabel, RadioGroup, Radio, List} from '@material-ui/core/'
import ExpansionPanelDetails from '@material-ui/core/AccordionDetails'
import ExpansionPanelSummary from '@material-ui/core/AccordionSummary'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import * as css from './SideBarItem.css'
import {SelectInput} from 'centric-ui-components'
import {A4_PAGE_SIZE, usePdfStore} from '@modules/pdf'

interface MyProps extends StyledProps {
  hierarchy?: string[]
  className?: string,
  type?: string
}

const QueryLimitConf = observer(function QueryLimitConf() {
  const {undo: {config}} = usePdfStore()
  return <FormControl>
    <InputLabel htmlFor='age-helper'>Limit</InputLabel>
    <Select
      value={config.queryLimit}
      onChange={(e) => config.queryLimit = parseInt(e.target.value.toString())}
      input={<Input name='age' id='age-helper'/>}
    >
      <MenuItem value={50}>50</MenuItem>
      <MenuItem value={250}>250</MenuItem>
      <MenuItem value={500}>500</MenuItem>
      {/* If you run into issues with these make sure your index has the correct inner limit settings:
                       PUT vlp-merch-option-version/_settings
                      {
                        "index.max_inner_result_window" : 9999999
                      }
                      */}
      <MenuItem value={1000}>1000</MenuItem>
      <MenuItem value={9999999}>No Limit</MenuItem>
    </Select>
  </FormControl>
})

const SectionConf = observer(function SectionConf() {
  const {vlp: {isVLPView}, undo: {onChangeSectionCoverSelection, showCoverPage, config: {sections, selectedTemplate, document}}, rhTemplate} = usePdfStore()

  return <List style={{width: '100%', paddingBottom: 15}}>
    <ListItem disabled={rhTemplate} disableGutters classes={{container: css.showLogo}}>
      <ListItemText primary={'Cover Page'}/>
      <ListItemSecondaryAction>
        <Checkbox
          disabled={rhTemplate}
          onChange={onChangeSectionCoverSelection}
          checked={showCoverPage ?? sections.cover}
        />
      </ListItemSecondaryAction>
    </ListItem>
    {/*<ListItem disableGutters classes={{container: css.showLogo}}>*/}
    {/*    <ListItemText primary={"Spec Glossary"} />*/}
    {/*    <ListItemSecondaryAction>*/}
    {/*        <Checkbox*/}
    {/*            onChange={(e)=> sections.specGlossary = !sections.specGlossary}*/}
    {/*            checked={sections.specGlossary}*/}
    {/*        />*/}
    {/*    </ListItemSecondaryAction>*/}
    {/*</ListItem>*/}
    <ListItem disabled={isVLPView || rhTemplate} disableGutters classes={{container: css.showLogo}}>
      <ListItemText primary={isVLPView ? 'Colors' : 'Products'}/>
      <ListItemSecondaryAction>
        <Checkbox
          disabled={isVLPView || rhTemplate}
          onChange={(e) => sections.products = !sections.products}
          checked={sections.products}
        />
      </ListItemSecondaryAction>
    </ListItem>
  </List>
})

interface PageListItemProps {
  label: string,
  value: string,
  fn?: string,
  parentStore?: string
}

const PDF_SIDEBAR_PAGE_ITEMS_PRODUCTS_VIEW: Array<PageListItemProps> = [
  {
    label: 'Show Logo', value: 'header.show'
  }, {
    label: 'Show Label', value: 'settings.showCardLabels', fn: 'toggleShowCardLabel', parentStore: 'stores'
  }, {
    label: 'Show Active Filters', value: 'showFilters'
  }, {
    label: 'Show Total Count', value: 'showTotalCount'
  }
]

const PDF_SIDEBAR_PAGE_ITEMS_GROUP_BY_VIEW: Array<PageListItemProps> = [
  ...PDF_SIDEBAR_PAGE_ITEMS_PRODUCTS_VIEW, {
    label: 'Show Group Count', value: 'showCount'
  }, {
    label: 'Show Horizontal Grouping Lines', value: 'showHrGroupingLines'
  }, {
    label: 'Show Vertical Grouping Lines', value: 'showVtGroupingLines'
  }
]

const PageConf = observer(function PageConf() {
  const {undo, undo: {config, selectedPageSize, selectedLogo}, selectedPageSize: selectedPDFPageSize, stores, templates, rhTemplate} = usePdfStore()
  const {
    catalog: {groupBy: {isProductView, hierarchy}, cardView_setImageRatio}
  } = stores
  const sidebarListItems = isProductView ? PDF_SIDEBAR_PAGE_ITEMS_PRODUCTS_VIEW : PDF_SIDEBAR_PAGE_ITEMS_GROUP_BY_VIEW

  return <div>
    {templates.length > 1 && <div>Show templates option</div>}
    <SelectInput
      name='Columns'
      itemValue='key'
      itemLabel='value'
      value={config && config.columns || ''}
      label='Columns'
      classes={{
        formControl: css.selectInput,
        selectOption: css.selectOption
      }}
      options={[
        {
          key: 'standard',
          value: `Standard(${selectedPDFPageSize === A4_PAGE_SIZE ? 6 : 8})`,
          disabled: false
        }, {
          key: 'compact',
          value: `Compact(${selectedPDFPageSize === A4_PAGE_SIZE ? 8 : 10})`,
          disabled: false
        }
      ]}
      onChange={(e) => { config.columns = e.target.value}}
      disabled={rhTemplate}
    />
    <FormControl style={{marginTop: '20px'}}>
      <FormLabel style={{fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)'}}>Image Ratio</FormLabel>
      <RadioGroup className={css.radioGroup} aria-label='position' onChange={(e, value) => {
        cardView_setImageRatio(value)
        config.imageRatio = value
      }} name='position' value={config.imageRatio}>
        <FormControlLabel
          className={css.label}
          value='square'
          control={<Radio color='primary'/>}
          label='Square'
          disabled={rhTemplate}
        />
        <FormControlLabel
          className={css.label}
          value='portrait'
          control={<Radio color='primary'/>}
          label='Portrait'
          disabled={rhTemplate}
        />
        <FormControlLabel
          className={css.label}
          value='landscape'
          control={<Radio color='primary'/>}
          label='Landscape'
          disabled={rhTemplate}
        />
      </RadioGroup>
    </FormControl>
    {config?.document && _.isArray(config.document) ? <SelectInput
                                                      name='pageSize'
                                                      itemValue='key'
                                                      disabled={rhTemplate}
                                                      itemLabel='value'
                                                      value={config && selectedPageSize || ''}
                                                      label='Page Size'
                                                      classes={{
                                                        formControl: css.selectInput,
                                                        selectOption: css.selectOption
                                                      }}
                                                      options={config.document.map(d => ({key: d.size, value: d.size, disabled: false}))}
                                                      onChange={(e) => { undo.selectedPageSize = e.target.value }}
                                                    /> :
     <TextField
       disabled
       label='Page Size'
       className={css.textField}
       defaultValue='A4'
       // helperText="Please select your currency"
       margin='dense'
     />}
    <TextField
      disabled
      label='Orientation'
      className={css.textField}
      defaultValue='landscape'
      // helperText="Please select your currency"
      margin='dense'
    />
    {hierarchy.length > 1 &&
	 <SelectInput
		 name='Layouts'
		 itemValue='key'
		 itemLabel='value'
		 value={config?.layout ?? 'row'}
		 label='Second level Groups'
		 disabled={rhTemplate}
		 classes={{
           formControl: css.selectInput,
           selectOption: css.selectOption
         }}
		 options={[
           {
             key: 'row',
             value: 'Show as Row',
             disabled: false
           }, {
             key: 'column',
             value: 'Show as Column',
             disabled: false
           }
         ]}
		 onChange={(e) => config.layout = e.target.value}
	 />}
    {config?.logos && config?.showLogo && <SelectInput
		name='Logo'
		itemValue='key'
		itemLabel='value'
		disabled={rhTemplate}
		itemLeftImage='leftImg'
		value={config && selectedLogo || ''}
		label='Logo'
		classes={{
          formControl: css.selectInput,
          selectOption: css.selectOption
        }}
		options={config?.logos?.map(d => ({key: d.name, value: d.name, leftImg: d.path ? <img className={classNames(css.leftImg)} src={require(`./../templates/vlp${d.path.slice(1)}`)}/> : null})) ?? []}
		onChange={(e) => { undo.selectedLogo = e.target.value }}
	/>}
    <List>
      {sidebarListItems.map((item: PageListItemProps, index) => <SidebarListItem item={item} index={index} key={index}/>)}
    </List>
  </div>
})

const SidebarListItem = observer<{ item: PageListItemProps, index: number }>(function SidebarListItem({item, index}) {
  const {undo: {config}, catalog, rhTemplate} = usePdfStore()
  return (
    <ListItem disabled={rhTemplate} key={index} disableGutters classes={{container: css.showLogo}}>
      <ListItemText primary={item.label}/>
      <ListItemSecondaryAction>
        <Checkbox
          disabled={rhTemplate}
          onChange={item.parentStore ? catalog[item.fn] : (e) => _.set(config, item.value, !_.get(config, item.value))}
          checked={item.parentStore ? _.get(catalog, item.value) : _.get(config, item.value)}
        />
      </ListItemSecondaryAction>
    </ListItem>
  )
})

const DocumentConf = observer<MyProps>(function DocumentConf(props) {
  const {undo: {selectedPdfDocument, selectedPdfDocument: {title, subject, subtitle}, showCoverPage}, rhTemplate} = usePdfStore(),
    disabled = rhTemplate || !showCoverPage

  return (
    <div className={css.container}>
      <TextField
        label='Page Title'
        className={css.textField}
        placeholder='Enter Page Title'
        disabled={disabled}
        value={title}
        onChange={(e) => {selectedPdfDocument.title = e.target.value}}
      />
      <TextField
        label='Page Subtitle'
        className={css.textField}
        placeholder='Enter Page Subtitle'
        value={subtitle}
        disabled={disabled}
        onChange={(e) => {selectedPdfDocument.subtitle = e.target.value}}
      />
      <TextField
        label='Page Subject'
        placeholder='Enter Page Subject'
        className={css.textField}
        value={subject}
        disabled={disabled}
        onChange={(e) => {selectedPdfDocument.subject = e.target.value}}
      />
    </div>
  )
})

export const SideBarItem = observer<MyProps>(function SideBarItem(props) {
  // const { classes } = props;
  const [expanded, setExpanded] = useState(true)
  return <Fragment>
    <ExpansionPanel elevation={0} className={css.expansionPanel} expanded={expanded} onChange={() => {setExpanded(!expanded)}}>
      <ExpansionPanelSummary className={css.expansionPanelSummary} expandIcon={<ExpandMoreIcon/>}>
        <Typography className={css.heading}>
          {
            {
              'document': 'Document',
              'page': 'Page',
              'sections': 'Section',
              'datasource': 'Query Limit'
            }[props.type]
          }
        </Typography>
        {/* <Typography className={classes.secondaryHeading}>I am an expansion panel</Typography> */}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={css.expansionPanelDetails}>
        {
          {
            'document': <DocumentConf/>,
            'page': <PageConf/>,
            'sections': <SectionConf/>,
            'datasource': DEBUG ? <QueryLimitConf/> : null
          }[props.type]
        }
      </ExpansionPanelDetails>
    </ExpansionPanel>
  </Fragment>
})



// WEBPACK FOOTER //
// ./src/modules/pdf/sideBar/SideBarItem.tsx